import React from "react";
import { __ } from "@wordpress/i18n";

const Footer = () => {
	return (
		<>
			<div className="footer">
				<div className="footer-content primary-text-color regular" style={{opacity: 0.5}}>
					<span>
						{__(
							"Enjoyed Access Control? Please leave us a rating. We really appreciate your support!",
							"access-control",
						)}
					</span>
					<span className="version primary-text-color regular" style={{opacity: 0.8}}>
						{__("Version ", "access-control")}
						{window.placAdminData.pluginVersion}
					</span>
				</div>
			</div>
			
		</>
	);
};

export default Footer;
